import { useMemo } from "react";
import useAuth from "./useAuth";
import {
  resolveStatusColors,
  getStatusStyle as buildStatusStyle,
  getEffectiveStatus as resolveEffectiveStatus,
} from "../utils/statusColors";

export default function useStatusColors() {
  const { statusColorConfig } = useAuth();

  const resolvedColors = useMemo(
    () => resolveStatusColors(statusColorConfig),
    [statusColorConfig],
  );

  return {
    resolvedColors,
    getStatusStyle: (status, slaPercentage) => {
      const effective = resolveEffectiveStatus(status, slaPercentage);
      return buildStatusStyle(effective, resolvedColors);
    },
    getEffectiveStatus: (status, slaPercentage) =>
      resolveEffectiveStatus(status, slaPercentage),
  };
}
